import { TiArrowUnsorted, TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";

const SortButton = ({ sortState, onClick }) => {
  const icons = {
    default: TiArrowUnsorted,
    ascending: TiArrowSortedUp,
    descending: TiArrowSortedDown
  };
  
  const Icon = icons[sortState] || TiArrowUnsorted;
  
  return (
    <button className="transparent-button" onClick={onClick}>
      <Icon className="ms-1" fontSize={20} />
    </button>
  );
};

export default SortButton;
